import { combineReducers } from 'redux';
import {calendar} from '../../shared/packages/TimeSlotCalendar';
import common from './common/common';
import offers from './data/offers/offers';
import equipment from './data/equipment/equipment';
import customer from './data/customer/customer';
import checkout from './data/checkout/checkout';
import plan from './data/plan/plan';
import review from './data/review/review';
import confirmation from './data/confirmation/confirmation';
import cancel from './data/cancel/cancel';
import quickCheckout from './data/quickCheckout/quickCheckout';
import omniSales from './pages/Omni/omniSales/localization';
import moversReview from './pages/Movers/review/review';
import moversConfirmation from './pages/Movers/confirmation/confirmation';
import moversInstall from './pages/Movers/install/install';
import account from './pages/Account/account/account';
import accountMultipleAddress from './pages/Account/multipleAddress/multipleAddress';
import collapse from './collapse/collapse';
import overlay from './overlay/overlay';
import suggestions from './suggestions/suggestions';
import dataLayer from './dataLayer/dataLayer';
import target from './target/target';
import {reducer as contentReducer} from '../../redux/modules/contentProvider/contentProvider';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

const rootReducer = combineReducers({
  account,
  accountMultipleAddress,
  calendar,
  cancel,
  checkout,
  collapse,
  common,
  confirmation,
  contentProvider: contentReducer,
  customer,
  dataLayer,
  target,
  equipment,
  form: formReducer,
  omniSales,
  moversInstall,
  moversConfirmation,
  moversReview,
  offers,
  overlay,
  plan,
  quickCheckout,
  review,
  suggestions,
  routing: routerReducer // keep this one last, seems to cause issues with webpack error reporting otherwise
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/index.js
 **/